module.exports = __webpack_public_path__ + "static/media/publish2.88681ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/publish2.png
// module id = 1502
// module chunks = 0